module.exports = __webpack_public_path__ + "static/img/table.06e5f5cc.svg";